"use client";

import Link from "next/link";
import { MoveLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BlogSectionLink() {
  return (
    <div className="w-full flex justify-center mt-14">
      <Link href="/blog" prefetch={false}>
        <Button size="xl" variant="berryBorder" aria-label="رفتن به صفحه بلاگ">
          رفتن به صفحه بلاگ
          <MoveLeft aria-hidden="true" />
        </Button>
      </Link>
    </div>
  );
}
